/**
 * Requesting data from ZOE gives us a lot more than just the game Id
 * (see ZoeSchema type in fetchDataFromZoe.ts), but for the purpose of this
 * leaderboard widget we only need the game Id. Furthermore, we cannot guarantee
 * that the configuration of the `output` property satisfies what we
 * expect with ZoeSchema.
 */
export const mockZoeConfig: { gameId: string } = {
  gameId: "c7bc78ac-bac6-4b44-92c4-52d363135fa3",
};
